<aside class="sidebar" [class.collapsed]="collapsed">

  <!-- Logo -->
  <div class="sidebar-logo">
    @if (!collapsed) {
      <span class="logo-text">KLIDI <span class="logo-dot">●</span></span>
    } @else {
      <span class="logo-icon">K</span>
    }
    <button class="collapse-btn" (click)="toggleSidebar()">
      <mat-icon>{{ collapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
    </button>
  </div>

  <!-- Main Nav -->
  <nav class="sidebar-nav">
    @for (item of visibleNavItems(); track item.label) {
      @if (!item.children) {
        <a class="nav-item" [routerLink]="item.route" routerLinkActive="active">
          <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
          @if (!collapsed) { <span class="nav-label">{{ item.label }}</span> }
        </a>
      } @else {
        <div class="nav-group">
          <div class="nav-item has-children" (click)="toggleItem(item)"
               [class.open]="item.expanded">
            <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
            @if (!collapsed) {
              <span class="nav-label">{{ item.label }}</span>
              <mat-icon class="chevron">{{ item.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
            }
          </div>
          @if (item.expanded && !collapsed) {
            <div class="nav-children">
              @for (child of item.children; track child.label) {
                <a class="nav-child" [routerLink]="child.route" routerLinkActive="active-child">
                  {{ child.label }}
                </a>
              }
            </div>
          }
        </div>
      }
    }
  </nav>

  <div class="sidebar-spacer"></div>

  <!-- Bottom Nav -->
  <nav class="sidebar-bottom">
    @for (item of bottomItems; track item.label) {
      @if (!item.children && !item.isLogout) {
        <a class="nav-item" [routerLink]="item.route" routerLinkActive="active">
          <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
          @if (!collapsed) { <span class="nav-label">{{ item.label }}</span> }
        </a>
      } @else if (item.children) {
        <div class="nav-group">
          <div class="nav-item has-children" (click)="toggleItem(item)" [class.open]="item.expanded">
            <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
            @if (!collapsed) {
              <span class="nav-label">{{ item.label }}</span>
              <mat-icon class="chevron">{{ item.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
            }
          </div>
          @if (item.expanded && !collapsed) {
            <div class="nav-children">
              @for (child of item.children!; track child.label) {
                <a class="nav-child" [routerLink]="child.route" routerLinkActive="active-child">{{ child.label }}</a>
              }
            </div>
          }
        </div>
      } @else if (item.isLogout) {
        <button class="nav-item logout-btn" (click)="logout()">
          <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
          @if (!collapsed) { <span class="nav-label">{{ item.label }}</span> }
        </button>
      }
    }

    @if (!collapsed) {
      <!-- Pinned means the sidebar stays expanded; unpinning collapses it to the icon rail.
           Same state the collapse chevron writes, so the two can never disagree. -->
      <div class="pin-toggle">
        <span>Pin Sidebar</span>
        <mat-slide-toggle [checked]="pinned" (change)="setPinned($event.checked)"
                          color="accent" aria-label="Pin sidebar"></mat-slide-toggle>
      </div>
    }
  </nav>

  <!-- Footer -->
  @if (!collapsed) {
    <footer class="sidebar-footer">
      <p>Licensed in Poland</p>
      <p>TULCARTIS SP. Z O.O.</p>
      <p>ul. Bartycka 22B/21A, Warszawa</p>
      <div class="footer-links">
        <a href="mailto:business@klidi.io"><mat-icon>mail</mat-icon> business&#64;klidi.io</a>
        <a href="https://klidi.io" target="_blank"><mat-icon>language</mat-icon> klidi.io</a>
      </div>
    </footer>
  }
</aside>
